/**
 *
 * @param {clientId} string - UUID string of the clients ID
 * @param {projectId} string - UUID string of the projects ID
 * @param {id} string - UUID string of the projects state ID
 * @dev - please note the structure of the object
 * @dev - {clientId} == Client
 * @dev - {clientId, projectId} == Project
 * @dev - {clientId, projectId, measureId} == Measure
 * @returns
 */
const bindIdsToLink = ({ clientId, projectId, id }) => {
  if (id && !clientId && !projectId) {
    return { clientId: id };
  } else if (id && clientId && !projectId) {
    return { clientId, projectId: id };
  } else if (id && clientId && projectId) {
    return { clientId, projectId, measureId: id };
  }
};

/**
 *
 * @param {clientId} string - UUID string of the clients ID
 * @param {projectId} string - UUID string of the projects ID
 * @param {id} string - UUID string of the projects state ID
 * @dev - please note the structure of the object
 * @dev - {clientId} == Client
 * @dev - {clientId, projectId} == Project
 * @dev - {clientId, projectId, stateId} == Measure
 * @returns
 */
export const createIdsFromData = ({ clientId, projectId, id }) => {
  if (id && !clientId && !projectId) {
    return { clientId: id };
  } else if (id && clientId && !projectId) {
    return { clientId, projectId: id };
  } else if (id && clientId && projectId) {
    return { clientId, projectId, stateId: id };
  }
};

export const createLinkInputPathFromData = ({ clientId, projectId, id }) => {
  const res = bindIdsToLink({ clientId, projectId, id });

  const arr = ["clients", res.clientId, res.projectId, res.measureId].filter(
    Boolean,
  );

  return arr.join("/");
};

export const createResultLinkFromDataAndToken = (
  { clientId, projectId, id },
  token,
) => {
  const res = bindIdsToLink({ clientId, projectId, id });

  const resPath = [res.clientId, res.projectId, res.measureId]
    .filter(Boolean)
    .join("/");

  return `${window.location.origin}/link/${resPath}/${token}`;
};
